export const DEFAULT_COUNTRIES = [
    {
        "id": "65",
        "name_en": "democratic-republic-of-congo",
        "name_fr": "république démocratique du congo",
        "img_src": "democratic-republic-of-congo.svg"
    },
    {
        "id": "84",
        "name_en": "france",
        "name_fr": "france",
        "img_src": "france.svg"
    },
    {
        "id": "249",
        "name_en": "united-states",
        "name_fr": "états unis",
        "img_src": "united-states.svg"
    },
    {
        "id": "34",
        "name_en": "brazil",
        "name_fr": "brésil",
        "img_src": "brazil.svg"
    },
    {
        "id": "8",
        "name_en": "angola",
        "name_fr": "angola",
        "img_src": "angola.svg"
    },
    {
        "id": "63",
        "name_en": "cyprus",
        "name_fr": "chypre",
        "img_src": "cyprus.svg"
    },
    {
        "id": "25",
        "name_en": "belgium",
        "name_fr": "belgique",
        "img_src": "belgium.svg"
    },
    {
        "id": "44",
        "name_en": "canada",
        "name_fr": "canada",
        "img_src": "canada.svg"
    },
    {
        "id": "52",
        "name_en": "china",
        "name_fr": "chine",
        "img_src": "china.svg"
    },
    {
        "id": "43",
        "name_en": "cameroon",
        "name_fr": "cameroun",
        "img_src": "cameroon.svg"
    },
    {
        "id": "203",
        "name_en": "senegal",
        "name_fr": "sénégal",
        "img_src": "senegal.svg"
    },
    {
        "id": "191",
        "name_en": "republic-of-the-congo",
        "name_fr": "république du congo",
        "img_src": "republic-of-the-congo.svg"
    },
    {
        "id": "166",
        "name_en": "nigeria",
        "name_fr": "nigeria",
        "img_src": "nigeria.svg"
    },
    {
        "id": "247",
        "name_en": "united-kingdom",
        "name_fr": "royaume uni",
        "img_src": "united-kingdom.svg"
    },
    {
        "id": "260",
        "name_en": "zimbabwe",
        "name_fr": "zimbabwe",
        "img_src": "zimbabwe.svg"
    },
]



// WEBPACK FOOTER //
// ./src/data/default_countries.js